import { Box, Container, Divider, makeStyles, Theme, Typography, useMediaQuery } from '@material-ui/core';
import React, { FC, useEffect, useRef } from 'react';
import 'react-multi-carousel/lib/styles.css';
import InfoSlider, { InfoSlideProps } from 'components/structures/about-us/InfoSlider';

interface SlideProps {
  title?: string;
  infoList: Array<InfoSlideProps>;
  subList?: Array<InfoSlideProps>;
}

interface SliderProps {
  sliderList: Array<SlideProps>;
}

const useStyles = makeStyles((theme: Theme) => ({
  section: {
    marginBottom: 0,
    marginTop: theme.spacing(16),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(24),
    },
  },
  itemSection: {
    overflowX: 'auto',
  },
  boxWrapper: {
    padding: theme.spacing(4, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(6, 3, 0),
    },
  },
  titleWrapper: {
    marginBottom: theme.spacing(6),
  },
  arrowsSection: {
    marginBottom: theme.spacing(11),
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
      marginBottom: theme.spacing(19),
    },
  },
  description: {
    margin: theme.spacing(3, 0, 6),
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(6),
  },
  text: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  sliderArrows: {
    marginTop: theme.spacing(10),
  },
  divider: {
    height: 1,
    width: '100%',
    backgroundColor: '#E5E5E5',
    marginBottom: theme.spacing(8),
    marginTop: '-5.8px',
  },
  titleWrapper1: {
    textAlign: 'center',
  },
  titleBlock: {
    display: 'inline-block',
  },
  title: {
    fontWeight: 700,
    fontSize: 24,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: 40,
    },
  },

  underline: {
    height: 2,
    width: '100%',
    backgroundColor: theme.palette.primary.main,
  },
  underlineDirectors: {
    height: 2,
    width: '100%',
    backgroundColor: theme.palette.primary.dark,
  },
}));

const RedesignLeadershipSlider: FC<SliderProps> = ({ sliderList }) => {
  const classes = useStyles();
  const isSmallUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  const dividerRefs = useRef<HTMLHRElement[]>([]);

  useEffect(() => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      dividerRefs.current.forEach((el) => {
        if (el) {
          el.style.marginTop = '-1.8px';
        }
      });
    }
  }, []);

  return (
    <Box className={classes.section} data-aos="fade-up">
      {sliderList.map(({ infoList, subList, title }, index) => (
        <Box key={index}>
          {!!title && (
            <>
              <Container style={{ position: 'relative' }}>
                <Box className={classes.titleWrapper1}>
                  <Box className={classes.titleBlock}>
                    <Typography color={title === 'Leadership' ? 'primary' : 'textSecondary'} className={classes.title}>
                      {title.toUpperCase()}
                    </Typography>
                    <Divider className={title === 'Leadership' ? classes.underline : classes.underlineDirectors} />
                  </Box>
                </Box>
              </Container>
              <Divider
                className={classes.divider}
                ref={(el) => {
                  if (el) dividerRefs.current[index] = el;
                }}
              />
            </>
          )}

          <InfoSlider blockTitle={title} list={infoList} />
          {title !== '' && <Box mt={isSmallUp ? 15 : 10} />}
          {subList && (
            <>
              <Box mt={3} />
              <InfoSlider list={subList} small />
            </>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default RedesignLeadershipSlider;
